import React, { useEffect } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import NavMenu from './Components/NavMenu';
import AboutMe from './Components/AboutMe';
import Skills from './Components/Skills';
import Contact from './Components/Contact';
import Education from './Components/Education';
import Projects from './Components/Projects';
import Experience from './Components/Experience';
import Homelab from './Components/Homelab';
import Blog from './Components/Blog'

const SITE_NAME = 'Elhacen Elmoustapha';

// Sets a descriptive document title for each page and starts it at the top.
function Page({ title, children }) {
  useEffect(() => {
    document.title = title ? `${title} | ${SITE_NAME}` : SITE_NAME;
    window.scrollTo(0, 0);
  }, [title]);
  return children;
}

const homeTitle = 'Aspiring Systems Administrator | Software Developer';

function App() {
  return (
    <BrowserRouter>
      <div className="App">
        <a href="#main-content" className="SkipLink">Skip to main content</a>
        <NavMenu />

        <main id="main-content" tabIndex="-1">
          <Routes>
            <Route exact path="/" element={<Page title={homeTitle}><AboutMe /></Page>} />
            <Route path="/AboutMe" element={<Page title={homeTitle}><AboutMe /></Page>} />
            <Route path="/Experience" element={<Page title="Experience"><Experience /></Page>} />
            <Route path="/Education" element={<Page title="Education"><Education /></Page>} />
            <Route path="/Contact" element={<Page title="Contact"><Contact /></Page>} />
            <Route path="/Skills" element={<Page title="Skills"><Skills /></Page>} />
            <Route path="/Projects" element={<Page title="Projects"><Projects /></Page>} />
            <Route path="/homelab" element={<Page title="Lab Status"><Homelab /></Page>} />
            <Route path="/Blog" element={<Page title="Blog"><Blog /></Page>} />
          </Routes>
        </main>
      </div>
    </BrowserRouter>
  );
}

export default App;
